import { ImageFragment } from '@lib/umbraco/generated/types.generated'
import { FC } from 'react'
interface GifProps {
  inView: boolean
  gif: ImageFragment
  sizes?: string
  priority?: boolean
  className?: string
}
const Gif: FC<GifProps> = ({ className, gif, sizes }) => {
  const hasMobileImage = gif?.mobileImage?.media.__typename === 'Image'

  return (
    <>
      {hasMobileImage ? (
        <>
          <picture>
            <source
              media="(max-width: 834px)"
              srcSet={`https://media.gubi.com/${(gif.mobileImage.media as ImageFragment).id}.gif`}
            />
            <source
              media="(min-width: 0px)"
              srcSet={`https://media.gubi.com/${gif.id}.gif`}
            />
            <img
              className={className}
              sizes={sizes}
              src={`https://media.gubi.com/${gif.id}.gif`}
              alt={gif.alt}
            />
          </picture>
        </>
      ) : (
        <img
          className={className}
          sizes={sizes}
          src={`https://media.gubi.com/${gif.id}.gif`}
          alt={gif.alt}
        />
      )}
    </>
  )
}

export default Gif
